import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { formatNumber } from "../../utilities/helpers";

import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

export default function GroupPurchaseChart({ data, jsonData }) {
  if (!data) return "";

  const comp = jsonData?.assignedCompTicketQty;
  const individual = jsonData?.assignedIndividualTicketQty;
  const group = jsonData?.assignedGroupTicketQty;

  const options = {
    chart: {
      type: "bar",
      height: 39,
      margin: [0, 0, 0, 0], // top, right, bottom, left
      background: "#fcfcfd",
      plotBackgroundColor: "#fcfcfd",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: [""],
      labels: {
        enabled: false,
      },
      stackLabels: {
        enabled: false,
      },
      lineWidth: 0,
      gridLineWidth: 0, // Disables grid lines on x-axis
      tickLength: 0,
      height: 40,
    },
    yAxis: {
      labels: {
        enabled: false,
      },
      stackLabels: {
        enabled: false,
      },
      min: 0,
      title: {
        text: "",
      },
      lineWidth: 0,
      gridLineWidth: 0, // Disables grid lines on y-axis
      tickLength: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: "percent",
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "Complimentary",
        data: [comp],
      },
      {
        name: "Group",
        data: [group],
      },
      {
        name: "Individual",
        data: [individual],
      },
    ],
  };
  return (
    <Card className="card--md stat-card card-with-border">
      <Card.Body className="d-flex-column flex-sm">
        <Card.Title as="h5">Ticket Assignment</Card.Title>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <ListGroup variant="flush">
          <ListGroup.Item className="d-flex justify-content-between border-bottom-0 small">
            <span className="info-text flex-sm info-text-dot info-text-dot--primary">
              Complimentary
            </span>
            <span className="fw-medium">{formatNumber(comp)}</span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between border-bottom-0 small">
            <span className="info-text flex-sm info-text-dot info-text-dot--tertiary">
              Group
            </span>
            <span className="fw-medium">{formatNumber(group)}</span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between border-bottom-0 small">
            <span className="info-text flex-sm info-text-dot info-text-dot--danger">
              Individual
            </span>
            <span className="fw-medium">{formatNumber(individual)}</span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between small mt-auto">
            <span className="fw-bold">Total</span>
            <span className="fw-bold">
              {formatNumber(comp + group + individual)}
            </span>
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
}
